import makeEvents from "../../../../helpers/event-creator.js";
const APP_EVENTS = makeEvents([
    'change-pass-form-submitted'
]);
export default APP_EVENTS;
